import React, { useEffect } from 'react';
import "./Loader.scss"
const Loader = ({ size = '50px', color = '#da0383' }) => {
    const sizeValue = typeof size === 'number' ? `${size}px` : size;
    
    
    return (
        <div className="loader-container" style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            width: '100%',
            padding: '20px 0'
        }} suppressHydrationWarning={true}>
            <svg
                viewBox="0 0 50 50"
                width={sizeValue}
                height={sizeValue}
                className="loader-svg loader-svg-animated"
                suppressHydrationWarning={true}
            >
                <path
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                    fill={color}
                    stroke={color}
                    strokeWidth="2"
                    className="loader-path"
                />
            </svg>
        </div>
    );
};

export default Loader;